import { Link, LinkProps } from "react-router-dom"
import { styled } from "@mui/material"

const StyledTableLink = styled(Link)<LinkProps>(({ theme }) => ({
  color: "#0B5563",
}))

export default StyledTableLink
